<template>
    <div :class="{'status': true, [status.replace('+', '')]: status}">
        {{ available_at_type && available_at == 'plain' && status == 'ending' ? 'Beschikbaar vanaf' : parseStatusText(status) }}

        <b-tooltip :label="`Beschikbaar vanaf ${moment(available_at).format('DD-MM-Y') }`" v-if="status == 'ending' && !!available_at && available_at_type == 'tooltip'">
            <b-icon size="is-small" icon="info-circle" />
        </b-tooltip>
        <span v-else-if="status == 'ending' && available_at_type == 'plain' && available_at">
            <br>
            {{ available_at ? moment(new Date(available_at)).format('DD-MM-Y') : available_at }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        status: {
            type: String,
            required: true
        },
        available_at: {
            type: String|Boolean,
            required: false,
            default: false
        },
        available_at_type: {
            type: String|Boolean,
            required: false,
            default: 'tooltip'
        }
    },

    methods: {
        parseStatusText(status) {
            switch(status) {
                case 'free':
                    return 'Vrij'
                break;
                case 'reserved':
                    return 'Gereserveerd'
                break;
                case 'taken':
                    return 'Verhuurd'
                break;
                case 'taken':
                    return 'Verhuurd'
                break;
                case 'taken+reserved':
                    return 'Verhuurd + Gereserveerd'
                break;
                case 'inactive':
                    return 'Inactief'
                break;
                case 'ending':
                    return 'Aflopend'
                break;
                case 'escalated':
                    return 'Geëscaleerd'
                break;
                case 'escalated_deurwaarder':
                    return 'Deurwaarder'
                break;
            }

        }
    }
}
</script>
